import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt="" style={{maxWidth: '100%'}}
                                                 src={require('@images/How to be confident in your judgement calls.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">isn't it interesting?</span>
                                            </div>

                                            <p>Do you see the spiral in the picture?…</p>

                                            <div className="border_subtitle">
                                                <img
                                                    src={require('@images/thought_suqure.png')}
                                                    alt="" align="right"/>Things are not always as they
                                                appear
                                            </div>

                                            <p>It may appear at first glance that there is a spiral in the
                                                centre of this image, but in fact, there is a series of
                                                perfectly round circles. This is
                                                known as a ‘Fraser Illusion’, first identified by Sir James
                                                Fraser in 1908.<a className="superscripttext"
                                                                  href="further_info.php?course=300"><sup>1</sup></a>&nbsp; This
                                                is one of many ‘optical illusions’ found in psychology where
                                                your vision defies the logic of your brain.</p>

                                            <div className="lightgreencontentbg">
                                                <div className="border_subtitle">Everyday illusions</div>
                                                <p>Our vision works at a sub-conscious level; the visual
                                                    cortex at the back of our brain interprets cellular
                                                    input from our optic nerve automatically,<a
                                                        className="superscripttext"
                                                        href="further_info.php?course=300"><sup>2</sup></a>&nbsp; explaining
                                                    how you will still see a spiral now even though you know
                                                    one does not exist.</p>
                                                <div className="uiheading">
                                                    <p className="cntareap  ">Illusions like this work
                                                        because the context around the stimuli (the circles
                                                        in this instance) is distracting. Our brain is
                                                        constantly processing masses of information, and not
                                                        just necessarily what you’re concentrating on, which
                                                        can lead to mental errors.</p>
                                                </div>
                                            </div>
                                            <br/>
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Similar to this illusion, in our working day we are
                                                bombarded with lots of distractions and we are
                                                required to make decisions all the time. Some decisions
                                                are small and trivial whilst others are
                                                grand and highly important. By taking a step back and
                                                looking at things rationally and objectively
                                                it becomes easier to make reasoned judgement that you
                                                can be confident with.</p>
                                            <p>This tool is all about <span className="green"><strong>how to be confident in making judgement calls</strong></span> and
                                                helps you to discover
                                                your decision making styles as well as providing you
                                                with insight into how others make decisions
                                                too. Knowing your decision making styles and when to
                                                apply them can increase your confidence
                                                in the judgements that you make.</p>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}